<div class="circle" #outer>
  <span #inner [ngStyle]="{'opacity': innerOpacity}">
    <div class="bump" #bump [ngStyle]="{'height': bumpHeight}"></div>
    <ng-template [ngIf]="info !== undefined && info.subtext !== undefined">
      <div class="main" [innerHtml]="breakSafe(info.text)" (click)="onTextClicked()"></div>
      <div class="sub" [innerHtml]="breakSafe(info.subtext)" (click)="onTextClicked()"></div>
    </ng-template>
    <ng-template [ngIf]="info !== undefined && info.dialog !== undefined&& info.title !== '[MOOD-LAYOUT]'">
      <div class="title" (click)="onDialogClicked()" [innerHtml]="breakSafe(info.title)"></div>
      <div *ngIf="info.dialog.thesis !== undefined" class="rating-box">
        <ng-template ngFor let-item let-i="index" [ngForOf]="createRating()">
          <ion-icon *ngIf="item" name="thumbs-up" (touchstart)="onStarSelected($event, i)" (click)="onStarSelected($event, i)" class="thumbs-up-{{i}}" ></ion-icon>
          <ion-icon *ngIf="!item" name="thumbs-up-outline" (touchstart)="onStarSelected($event, i)" (click)="onStarSelected($event, i)" class="thumbs-up-{{i}}"></ion-icon>
        </ng-template>
      </div>
    </ng-template>
    <ng-template [ngIf]="info !== undefined && info.dialog !== undefined&& info.title === '[MOOD-LAYOUT]'">
      <div class="title mood-title" (click)="onDialogClicked()" [innerHtml]="breakSafe(moodText)"></div>
      <div class="mood-box">
        <ng-template ngFor let-item let-i="index" [ngForOf]="createRating()">
          <div class="mood" (touchstart)="onStarSelected($event, i)" (click)="onStarSelected($event, i)">
            <div *ngIf="i + 1 == value" class="mood-{{i}} mood-inner selected" ></div>
            <div *ngIf="i + 1 != value" class="mood-{{i}} mood-inner"></div>
          </div>
        </ng-template>
      </div>
    </ng-template>
  </span>
</div>  
